import axios from 'axios';
import store from "@/store";
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import SecureLS from "secure-ls";

const ls = new SecureLS({ isCompression: false });

const Request = axios.create({
  // baseURL: "http://127.0.0.1:8000/api",
  baseURL: "https://pfras.inecnigeria.org/api",
  timeout: 30000, 
});

Request.interceptors.request.use(
  (config) => {
    let data = ls.get("pfras");
    if (data) {
      const token = JSON.parse(data).auth.token;
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Request.interceptors.request.use(
  (config) => {
    commitData(true, null);
    NProgress.start()

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

Request.interceptors.response.use(
  (resp) => {
    NProgress.done();
    commitData(false, null);

    let response = resp.data;
    if (response && response.status_code == 201 || response.status_code == 206) {
      store.commit("shared/setSuccessResponse", response.status_message);
    }

    if (response) {
      return response;
    }
  },
  (error) => {
    NProgress.done()

    let err = "Something went wrong, we're unable to process your request, please try again!";

    if (error.code === "ECONNABORTED") {
      err = "Request timed out. Please check your internet connection and try again.";
    } else if (error.response) {
      if (error.response.status === 401 && error.response.data.message === "Unauthenticated.") {
        err = error.response.data.message;
        store.commit("auth/logout");
      } else if (error.response.data.message) {
        err = error.response.data.message;
      } else if (error.response.data.data) {
        err = error.response.data.data;
      } else if (error.response.data.errors) {
        err = error.response.data.errors;
      } else if (error.response.data.data?.message) {
        err = error.response.data.data.message;
      }
    }

    commitData(false, err);

    return error;
  }
);

const commitData = function (type, msg) {
  store.commit("shared/setLoading", type);
  store.commit("shared/setErrorResponse", msg);
};

export default Request;
